// extracted by mini-css-extract-plugin
module.exports = {"info":"AnalysisQuantityDetail_info__2oY2L","icon":"AnalysisQuantityDetail_icon__1a1Qm"};